module.exports = __webpack_public_path__ + "img/ssh.7db1fb4d.svg";